<template>
    <small-dialog
        v-model="dialog"
        @ok="save"
        loading="period"
        title="Buat Periode Baru"
        okButton="buat"
        scrollable
    >
        <template #activator="{ on }">
            <div class="text-right mb-4">
                <v-btn
                    v-on="on"
                    color="primary"
                    rounded
                >
                    buat program
                </v-btn>
            </div>
        </template>

        <period-form v-model="period"></period-form>
    </small-dialog>
</template>

<script>
import PeriodForm from './PeriodForm'
import SmallDialog from '@/components/dialog/SmallDialog'
import period from './period'

export default {
    components: {
        PeriodForm,
        SmallDialog,
    },

    data() {
        return {
            dialog: false,
            period: period(),
        }
    },

    methods: {
        save() {
            this.$api
                .post(
                    'period',
                    {
                        title: this.period.title,
                        is_active: this.period.isActive,
                        is_visible: this.period.isVisible,
                        slug: this.period.slug,
                        is_trial: this.period.isTrial,
                        is_specific: this.period.isSpecific,
                        contact_type: this.period.contactType,
                        price: this.period.price,
                        description: this.period.description,
                        requirement: this.period.requirement,
                        is_content_registration:
                            this.period.is_content_registration,
                        content: this.period.content,
                        kelon_group_id: this.period.kelonGroupId,
                    },
                    { loader: 'period' }
                )
                .then((response) => {
                    if (response.data.created) {
                        this.dialog = false
                        this.period = period()
                        this.$emit('created')
                    }
                })
        },
    },
}
</script>
